import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';
import Load from 'components/Load';

const AsyncConsentContainer = Load(() => import(/* webpackChunkName: "consent-page" */'./containers/ConsentContainer'));

const PrivacyRoute = <Route key={'consent'} path={`${basePath}/consent`} component={AsyncConsentContainer} /> ;

export default PrivacyRoute;
